import { render, staticRenderFns } from "./jd-tabs-permission.vue?vue&type=template&id=13f2a591&scoped=true"
import script from "./jd-tabs-permission.vue?vue&type=script&lang=js"
export * from "./jd-tabs-permission.vue?vue&type=script&lang=js"
import style0 from "./jd-tabs-permission.vue?vue&type=style&index=0&id=13f2a591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2a591",
  null
  
)

export default component.exports